module.exports = __webpack_public_path__ + "static/media/42x38-11.faeb1f82.png";